import { getAgreementData } from '@partiu/api/dashboard/api';
import { IAgreement } from '@partiu/api/dashboard/types';
import { getLanding } from '@partiu/api/landing/api';
import { parseAgreementToTheme, parseAgreementToThemeDash } from '@partiu/api/landing/utils';

export async function slugResolver() {
  let slug = window.location.host.split('.')[0];

  if (slug.includes('localhost')) slug = 'liggarevistas';

  const agreement: IAgreement = await getLanding(slug);
  return parseAgreementToTheme(agreement);
}

export async function slugDashResolver() {
  const token = localStorage.getItem('token');

  if (token) {
    const agreement: IAgreement = await getAgreementData();

    return parseAgreementToThemeDash(agreement);
  }
  return parseAgreementToThemeDash({
    primaryColor: '#e53a35',
    primaryFontColor: '#ffffff',
    secondaryColor: '#fb8c00',
    secondaryFontColor: '#ffffff',
    menuColor: '#ffffff',
    menuFontColor: '#000000',
    id: null,
    name: 'Partiu',
    logo: 'https://partiu-rest-s3.s3.amazonaws.com/logos/Partiu-Logo-Colorida.png',
    email: 'suporte@partiu.com.br',
    telephone: '(21) 97420-4416',
    banners: [],
    hasLanding: false,
    inAppLanding: false,
    createdAt: '',
    updatedAt: '',
    allowCpfLoginMethod: false,
    allowCreationOfAgreements: false,
    allowMonthlyReport: false,
    allowProductSelling: false,
    allowPromocodeLoginMethod: false,
    sendBookEmail: false,
    enableSendingBookEmail: false,
    totalImportedUsers: 0,
    totalUsers: 0,
    children: [],
    childrenList: [],
    allowPushNotifications: false,
    allowReferral: false,
    physicalCard: false,
    integrationId: null,
    bePartnerModule: false,
    bookstoreModule: false,
    localModule: false,
    bookstoreTypes: [],
    cinemaModule: false,
    cpfModule: false,
    ecommerceModule: false,
    econometerModule: false,
    physicalCardModule: false,
    planSaleModule: false,
    promocodeModule: false,
    pushNotificationModule: false,
    referralModule: false,
    financialDashboard: false,
    slugAppIos: '',
    slugAppAndroid: '',
  });
}

export async function bookstoreSlugResolver() {
  let slug = window.location.host.split('.')[0];

  if (slug.includes('localhost')) slug = 'liggarevistas';

  const agreement: IAgreement = await getLanding(slug, 'bookstore');
  return parseAgreementToTheme(agreement);
}
